"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

// JCG-4543: 2026년 3회 실기 복원 참여 안내. 다음 회차에는 별도 키를 사용한다.
const STORAGE_KEY = "restoration-participation:2026-3";
const POPUP_ENABLED = true;

export default function RestorationParticipationPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!POPUP_ENABLED) return;
    try {
      if (localStorage.getItem(STORAGE_KEY) || sessionStorage.getItem(STORAGE_KEY)) return;
    } catch {
      // 저장소가 차단된 브라우저에서도 안내와 닫기는 사용할 수 있다.
    }
    const timer = window.setTimeout(() => setOpen(true), 600);
    return () => window.clearTimeout(timer);
  }, []);

  function dismiss(permanent = false) {
    setOpen(false);
    try {
      sessionStorage.setItem(STORAGE_KEY, "dismissed");
      if (permanent) localStorage.setItem(STORAGE_KEY, "dismissed");
    } catch {
      // 저장 실패가 닫기나 참여 링크 이동을 막지 않게 한다.
    }
  }

  return (
    <Dialog open={open} onOpenChange={(nextOpen) => { if (!nextOpen) dismiss(); }}>
      <DialogContent className="max-h-[calc(100dvh-2rem)] gap-0 overflow-y-auto overscroll-contain rounded-3xl p-0 sm:max-w-[420px]">
        <div className="bg-amber-50 px-6 pt-7 pb-4 dark:bg-amber-950/40">
          <Image
            src="/main/post-exam-restoration_gamja.webp"
            alt="시험지를 들고 반갑게 손을 흔드는 감자"
            width={240}
            height={240}
            className="mx-auto h-44 w-44 object-contain sm:h-52 sm:w-52"
          />
          <DialogHeader className="mt-2 text-center sm:text-center">
            <DialogTitle className="text-balance text-2xl leading-snug font-bold">
              시험 보느라<br />정말 수고했어요!
            </DialogTitle>
            <DialogDescription className="pt-1 text-sm leading-relaxed">
              열심히 달려온 여러분께 감자가 박수를 보내요.
            </DialogDescription>
          </DialogHeader>
        </div>
        <div className="px-6 pt-5 pb-4 text-center">
          <h3 className="text-lg font-semibold">두근두근, 함께 문제를 복원해요</h3>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
            기억나는 지문, 보기, 코드 한 줄도 좋아요.<br />
            여러분의 기억 한 조각이 큰 도움이 돼요.
          </p>
          <Button asChild size="lg" className="mt-5 w-full touch-manipulation rounded-xl bg-amber-600 text-white hover:bg-amber-700 dark:bg-amber-400 dark:text-amber-950 dark:hover:bg-amber-300">
            <Link href="/community/restoration" onClick={() => dismiss()}>
              두근두근 문제 복원 참여하기
            </Link>
          </Button>
          <Button variant="ghost" className="mt-2 min-h-11 w-full touch-manipulation text-muted-foreground" onClick={() => dismiss(true)}>
            다시 보지 않기
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
